import React from "react";

export default function MyButton({
  title,
  onClick,
  disabled,
  loading,
  className,
  variant = "contained",
  type,
  startIcon,
  endIcon,
}) {
  const containedVariant =
    "text-white bg-primary hover:bg-primaryDark border border-primaryDark";
  const outlinedVariant =
    "text-gray-600 bg-gray-100 hover:bg-gray-200 border border-gray-200";
  return (
    <button
      onClick={onClick}
      disabled={loading || disabled}
      type={type}
      className={`${className} p-2.5 px-4 min-w-40 text-sm uppercase shadow rounded-lg duration-500 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:border-none flex items-center justify-center gap-2 ${
        variant === "contained" && containedVariant
      } ${variant === "outlined" && outlinedVariant}`}
    >
      {startIcon} {loading ? "Please wait.." : title} {endIcon}
    </button>
  );
}
